export default "__VITE_PUBLIC_ASSET__559b5580__"